var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{directives:[{name:"editable",rawName:"v-editable",value:(_vm.cms),expression:"cms"}],class:[_vm.name, _vm.getClassName],style:(_vm.mainCssVars),attrs:{"id":`${_vm.cms.scroll_id}`}},[_c('grid',{class:[`${_vm.name}__grid`],attrs:{"layout":[
      {
        size: 1,
        columns: 'repeat(12, 1fr)',
        gap: '6px',
      },
      {
        size: 2,
        columns: 'repeat(24, 1fr)',
        gap: '10px',
      },
    ]}},[_c('grid-item',{class:[`${_vm.name}__grid-item`, `${_vm.name}__main`],attrs:{"layout":[
        { size: 1, x: 1, width: 12 },
        { size: 3, x: 1, width: 24 },
      ]}},_vm._l((_vm.cms.main),function(item){return _c(item.component,{directives:[{name:"editable",rawName:"v-editable",value:(item),expression:"item"}],key:item._uid,tag:"component",class:`${_vm.name}__main-content`,attrs:{"cms":item}})}),1),_vm._v(" "),_c('grid-item',{class:[`${_vm.name}__grid-item`, `${_vm.name}__overlay`],attrs:{"layout":[
        { size: 1, x: 1, width: 12 },
        { size: 3, x: 1, width: 24 },
      ],"v-if":_vm.cms.overlay.length > 0}},_vm._l((_vm.cms.overlay),function(item){return _c(item.component,{directives:[{name:"editable",rawName:"v-editable",value:(item),expression:"item"}],key:item._uid,tag:"component",attrs:{"cms":item}})}),1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }